import { STORAGE_KEYS } from './constants/storageKeys';
import { HELP_CENTER_DEFAULT_URL } from './constants/helpCenter.constants';

export function getHelpCenterUrl(): string {
    return process.env.REACT_APP_HELP_CENTER_URL || HELP_CENTER_DEFAULT_URL;
}

function readFromStorage(key: string): string | null {
    return sessionStorage.getItem(key) || localStorage.getItem(key);
}

export function openHelpCenter(): void {
    const baseUrl = getHelpCenterUrl();
    const token = readFromStorage(STORAGE_KEYS.AUTH_TOKEN);
    const orgId = readFromStorage(STORAGE_KEYS.ORG_ID);
    const userId = readFromStorage(STORAGE_KEYS.USER_ID);

    let url = baseUrl;
    if (token && orgId && userId) {
        const params = new URLSearchParams({ token, orgId, userId });
        url = `${baseUrl}?${params.toString()}`;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
}
